import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class DrugInteractionDTO extends BaseDTO {
  interactionId: number;
  source: string;

  drugInteractionCategoryA: NameValueDTO;
  drugInteractionCategoryB: NameValueDTO;
  onset: NameValueDTO;
  severity: NameValueDTO;
  documentation: NameValueDTO;
  management: NameValueDTO;

  categoryAATCs: NameValueDTO[];
  categoryBATCs: NameValueDTO[];
}
